export const TICKS_POLLING_INTERVAL = process.env.TICKS_POLLING_INTERVAL || 15000
